import accountableHelper from "./accountables";

function createRequestBody(payload) {
  return {
    data: {
      attributes: { cpf: payload.physical.cpf },
      relationships: accountableHelper.buildAccountableRelationships(payload)
    }
  };
}

export default { createRequestBody };



// WEBPACK FOOTER //
// ./src/API/helpers/physicals.js